/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { completePurchaseOrder } from '../fn/purchase-order/complete-purchase-order';
import { CompletePurchaseOrder$Params } from '../fn/purchase-order/complete-purchase-order';
import { createPurchaseOrder } from '../fn/purchase-order/create-purchase-order';
import { CreatePurchaseOrder$Params } from '../fn/purchase-order/create-purchase-order';
import { deletePurchaseOrder } from '../fn/purchase-order/delete-purchase-order';
import { DeletePurchaseOrder$Params } from '../fn/purchase-order/delete-purchase-order';
import { exportPurchaseOrders } from '../fn/purchase-order/export-purchase-orders';
import { ExportPurchaseOrders$Params } from '../fn/purchase-order/export-purchase-orders';
import { getNextPurchaseOrderNumber } from '../fn/purchase-order/get-next-purchase-order-number';
import { GetNextPurchaseOrderNumber$Params } from '../fn/purchase-order/get-next-purchase-order-number';
import { getPurchaseOrder } from '../fn/purchase-order/get-purchase-order';
import { GetPurchaseOrder$Params } from '../fn/purchase-order/get-purchase-order';
import { getPurchaseOrders } from '../fn/purchase-order/get-purchase-orders';
import { GetPurchaseOrders$Params } from '../fn/purchase-order/get-purchase-orders';
import { patchPurchaseOrder } from '../fn/purchase-order/patch-purchase-order';
import { PatchPurchaseOrder$Params } from '../fn/purchase-order/patch-purchase-order';
import { patchPurchaseOrderAmountValidation } from '../fn/purchase-order/patch-purchase-order-amount-validation';
import { PatchPurchaseOrderAmountValidation$Params } from '../fn/purchase-order/patch-purchase-order-amount-validation';
import { patchPurchaseOrderGreenLights } from '../fn/purchase-order/patch-purchase-order-green-lights';
import { PatchPurchaseOrderGreenLights$Params } from '../fn/purchase-order/patch-purchase-order-green-lights';
import { PurchaseOrder } from '../models/purchase-order';
import { PurchaseOrderSearchResult } from '../models/purchase-order-search-result';
import { purchaseOrdersUuidDocumentFileKeyGet } from '../fn/purchase-order/purchase-orders-uuid-document-file-key-get';
import { PurchaseOrdersUuidDocumentFileKeyGet$Params } from '../fn/purchase-order/purchase-orders-uuid-document-file-key-get';
import { searchPurchaseOrders } from '../fn/purchase-order/search-purchase-orders';
import { SearchPurchaseOrders$Params } from '../fn/purchase-order/search-purchase-orders';
import { updatePurchaseOrder } from '../fn/purchase-order/update-purchase-order';
import { UpdatePurchaseOrder$Params } from '../fn/purchase-order/update-purchase-order';


/**
 * Purchase order operations
 */
@Injectable({ providedIn: 'root' })
export class PurchaseOrderApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPurchaseOrders()` */
  static readonly GetPurchaseOrdersPath = '/purchase-orders';

  /**
   * Retrieve all the purchase orders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrders$Response(params: GetPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrderSearchResult>> {
    const obs = getPurchaseOrders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all the purchase orders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrders(params: GetPurchaseOrders$Params, context?: HttpContext): Observable<PurchaseOrderSearchResult> {
    const resp = this.getPurchaseOrders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrderSearchResult>): PurchaseOrderSearchResult => r.body)
    );
  }

  /** Path part for operation `createPurchaseOrder()` */
  static readonly CreatePurchaseOrderPath = '/purchase-orders';

  /**
   * Create a new purchase order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPurchaseOrder$Response(params: CreatePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = createPurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new purchase order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPurchaseOrder(params: CreatePurchaseOrder$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.createPurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `searchPurchaseOrders()` */
  static readonly SearchPurchaseOrdersPath = '/puchase-orders/search';

  /**
   * search purchase orders based on criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPurchaseOrders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPurchaseOrders$Response(params: SearchPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrderSearchResult>> {
    const obs = searchPurchaseOrders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * search purchase orders based on criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPurchaseOrders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPurchaseOrders(params: SearchPurchaseOrders$Params, context?: HttpContext): Observable<PurchaseOrderSearchResult> {
    const resp = this.searchPurchaseOrders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrderSearchResult>): PurchaseOrderSearchResult => r.body)
    );
  }

  /** Path part for operation `exportPurchaseOrders()` */
  static readonly ExportPurchaseOrdersPath = '/purchase-orders/export';

  /**
   * Export purchase orders based on criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPurchaseOrders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportPurchaseOrders$Response(params: ExportPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = exportPurchaseOrders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export purchase orders based on criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPurchaseOrders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportPurchaseOrders(params: ExportPurchaseOrders$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.exportPurchaseOrders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getPurchaseOrder()` */
  static readonly GetPurchaseOrderPath = '/purchase-orders/{uuid}';

  /**
   * Get purchase order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchaseOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrder$Response(params: GetPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = getPurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get purchase order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchaseOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchaseOrder(params: GetPurchaseOrder$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.getPurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `updatePurchaseOrder()` */
  static readonly UpdatePurchaseOrderPath = '/purchase-orders/{uuid}';

  /**
   * Update a Purchase Order Entity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseOrder$Response(params: UpdatePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = updatePurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a Purchase Order Entity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePurchaseOrder(params: UpdatePurchaseOrder$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.updatePurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `deletePurchaseOrder()` */
  static readonly DeletePurchaseOrderPath = '/purchase-orders/{uuid}';

  /**
   * Delete a Purchase Order Entity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePurchaseOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePurchaseOrder$Response(params: DeletePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deletePurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a Purchase Order Entity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePurchaseOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePurchaseOrder(params: DeletePurchaseOrder$Params, context?: HttpContext): Observable<void> {
    const resp = this.deletePurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchPurchaseOrder()` */
  static readonly PatchPurchaseOrderPath = '/purchase-orders/{uuid}';

  /**
   * Patch a Purchase Order Entity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPurchaseOrder()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchPurchaseOrder$Response(params: PatchPurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = patchPurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Patch a Purchase Order Entity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPurchaseOrder$Response()` instead.
   *
   * This method sends `application/json-patch+json` and handles request body of type `application/json-patch+json`.
   */
  patchPurchaseOrder(params: PatchPurchaseOrder$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.patchPurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `purchaseOrdersUuidDocumentFileKeyGet()` */
  static readonly PurchaseOrdersUuidDocumentFileKeyGetPath = '/purchase-orders/{uuid}/document/{fileKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchaseOrdersUuidDocumentFileKeyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchaseOrdersUuidDocumentFileKeyGet$Response(params: PurchaseOrdersUuidDocumentFileKeyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = purchaseOrdersUuidDocumentFileKeyGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `purchaseOrdersUuidDocumentFileKeyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  purchaseOrdersUuidDocumentFileKeyGet(params: PurchaseOrdersUuidDocumentFileKeyGet$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.purchaseOrdersUuidDocumentFileKeyGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `completePurchaseOrder()` */
  static readonly CompletePurchaseOrderPath = '/purchase-orders/{uuid}/complete';

  /**
   * Complete the purchase order after reconciliation of the invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completePurchaseOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completePurchaseOrder$Response(params: CompletePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = completePurchaseOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete the purchase order after reconciliation of the invoice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `completePurchaseOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completePurchaseOrder(params: CompletePurchaseOrder$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.completePurchaseOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `patchPurchaseOrderGreenLights()` */
  static readonly PatchPurchaseOrderGreenLightsPath = '/purchase-orders/{uuid}/green-lights';

  /**
   * Green light validation of a  Purchase Order Entity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPurchaseOrderGreenLights()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchPurchaseOrderGreenLights$Response(params: PatchPurchaseOrderGreenLights$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = patchPurchaseOrderGreenLights(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Green light validation of a  Purchase Order Entity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPurchaseOrderGreenLights$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchPurchaseOrderGreenLights(params: PatchPurchaseOrderGreenLights$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.patchPurchaseOrderGreenLights$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `patchPurchaseOrderAmountValidation()` */
  static readonly PatchPurchaseOrderAmountValidationPath = '/purchase-orders/{uuid}/admin';

  /**
   * Director validation of a Purchase Order amount.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPurchaseOrderAmountValidation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchPurchaseOrderAmountValidation$Response(params: PatchPurchaseOrderAmountValidation$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
    const obs = patchPurchaseOrderAmountValidation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Director validation of a Purchase Order amount.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPurchaseOrderAmountValidation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchPurchaseOrderAmountValidation(params: PatchPurchaseOrderAmountValidation$Params, context?: HttpContext): Observable<PurchaseOrder> {
    const resp = this.patchPurchaseOrderAmountValidation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PurchaseOrder>): PurchaseOrder => r.body)
    );
  }

  /** Path part for operation `getNextPurchaseOrderNumber()` */
  static readonly GetNextPurchaseOrderNumberPath = '/purchase-orders/next-order-number';

  /**
   * get the next purchase order number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNextPurchaseOrderNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextPurchaseOrderNumber$Response(params?: GetNextPurchaseOrderNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getNextPurchaseOrderNumber(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * get the next purchase order number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNextPurchaseOrderNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextPurchaseOrderNumber(params?: GetNextPurchaseOrderNumber$Params, context?: HttpContext): Observable<string> {
    const resp = this.getNextPurchaseOrderNumber$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
